import * as React from 'react';

function SvgContactPin(props) {
  return (
    <svg width="3em" height="3em" viewBox="0 0 26.204 38.435" {...props}>
      <path
        d="M12.493 37.742C11.983 37.14 0 22.873 0 13.557A13.35 13.35 0 0113.1 0a13.391 13.391 0 0113.1 13.554c.041 9.319-12.023 23.588-12.537 24.191l-.588.69zM1.542 13.557c0 7.625 9.115 19.458 11.541 22.471 2.438-3.01 11.612-14.845 11.579-22.466A11.846 11.846 0 0013.1 1.543 11.807 11.807 0 001.542 13.557zm5.945-.431A5.615 5.615 0 1113.1 18.75a5.627 5.627 0 01-5.613-5.625zm1.542 0A4.073 4.073 0 1013.1 9.044a4.081 4.081 0 00-4.071 4.081z"
        fill="#eea804"
      />
    </svg>
  );
}

export default SvgContactPin;
